import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./tab.css";
import documents from "../../../assets/img/documents.png";

export default function Tab() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { key: "council", label: "총학생회 소개", path: "/stdcouncil/council" },
    { key: "organization", label: "조직도", path: "/stdcouncil/organization" },
    { key: "map", label: "지도", path: "/stdcouncil/map" },
    { key: "documents", label: "자료실", path: "/documents", icon: documents },
  ];

  const activeTab = tabs.find(tab =>
    location.pathname.startsWith(tab.path)
  )?.key;

  return (
    <div className="tab-wrapper">
      <div className="tab-bar">
        {tabs.map(tab => (
          <button
            key={tab.key}
            className={`tab-button ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => navigate(tab.path)}
          >
            {tab.icon && (
              <img src={tab.icon} alt="" className="tab-icon" />
            )}
            {tab.label}
          </button>
        ))}
      </div>

      <div className="title">
        <h2>{tabs.find(t => t.key === activeTab)?.label}</h2>
      </div>
    </div>
  );
}
